import { Document, Image, Page, Text, View } from '@react-pdf/renderer'

import diagramClockPNG from '/assets/report/diagram-clock.png'
import diagramNeedlePNG from '/assets/report/diagram-needle.png'
import analizePNG from '/assets/report/report_2-analise.jpg'
import coachPNG from '/assets/report/report_2-coach.jpg'
import reasonsPNG from '/assets/report/report_2-reasons.jpg'
import scorePNG from '/assets/report/report_2-score.jpg'
import signalsPNG from '/assets/report/report_2-signals.jpg'
import titlePNG from '/assets/report/report_2-title.jpg'

import {
  SurveyReportScoringRanges,
  SurveyTotalReport
} from '../../../../api/services/user_assignment_codes/types.ts'
import { PdfCircle } from '../../../pdf/PdfCircle.tsx'
import { getAveragePercentagePatients } from '../handlers.ts'
import Signals, { SIGNALS } from '../Signals'
import { PDF_CONTENT } from './pdfContent.ts'
import { surveyReportPDFStyle } from './style.ts'

type Props = {
  data: SurveyTotalReport | null | undefined
}

const SurveyReportPDF = (props: Props) => {
  const styles = surveyReportPDFStyle()
  const pdf = PDF_CONTENT

  const avaregaPatients = getAveragePercentagePatients(
    props.data?.scoring_ranges as SurveyReportScoringRanges[],
    props.data?.total_patients_count as number
  )

  const chunkArray = <T,>(array: T[], size: number): T[][] => {
    const result: T[][] = []

    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size))
    }

    return result
  }

  const rows = chunkArray(props.data?.conclusions ?? [], 2)

  const needleRotateAdjust = 45
  const rotateZero = -180 + needleRotateAdjust
  const max = props.data?.scoring_ranges[2].max_score ?? 1
  const avr = props.data?.average_score ?? 1
  const rotate = rotateZero + (avr / max) * 180

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.imageWrapper}>
          <Image style={styles.diagram} src={titlePNG} />
        </View>

        <Text style={[styles.text, pdf.paragraf_1_1.style ?? {}]}>
          {pdf.paragraf_1_1.text}
        </Text>
        <Text style={[styles.text, pdf.paragraf_1_2.style ?? {}]}>
          {pdf.paragraf_1_2.text}
        </Text>
        <Text style={[styles.text, pdf.paragraf_1_3.style ?? {}]}>
          {pdf.paragraf_1_3.text}
        </Text>
        <Text style={[styles.text, pdf.paragraf_1_4.style ?? {}]}>
          {pdf.paragraf_1_4.text}
        </Text>
        <Text style={[styles.text, pdf.paragraf_1_5.style ?? {}]}>
          {pdf.paragraf_1_5.text}
        </Text>

        {/*Aktualny wynik raportu*/}
        <View style={styles.section} break>
          <View style={styles.imageWrapper}>
            <Image
              style={{ width: 515, height: (515 * 808) / 1920 }}
              src={scorePNG}
            />
          </View>

          <View style={{ flexDirection: 'row', marginTop: 0 }}>
            <View style={{ alignItems: 'center', justifyContent: 'center' }}>
              <View
                style={{
                  position: 'relative',
                  width: 150,
                  height: 150
                }}
              >
                <Image style={styles.smallDiagram} src={diagramClockPNG} />
                <Image
                  style={[
                    styles.smallDiagram,
                    { transform: `rotate(${rotate}deg)` }
                  ]}
                  src={diagramNeedlePNG}
                />
                <Text style={styles.textDiagram_1}>{avr}</Text>
                <Text style={styles.textDiagram_2}>/ {max} pkt</Text>
              </View>
            </View>

            <View style={{ flex: 1, flexDirection: 'column' }}>
              <Text style={[styles.text, pdf.p_wynik_2_2_1a.style ?? {}]}>
                {pdf.p_wynik_2_2_1a.text}{' '}
                <Text
                  style={[
                    styles.text,
                    { fontSize: 16, fontWeight: 'bold', paddingVertical: 0 }
                  ]}
                >
                  {props.data?.total_patients_count}
                  {props.data?.total_patients_count === 1
                    ? ' zawodnik'
                    : ' zawodników'}
                </Text>
              </Text>

              <Text
                style={[
                  styles.text,
                  pdf.p_wynik_2_2_1.style ?? {},
                  { flex: 1 }
                ]}
              >
                {pdf.p_wynik_2_2_1.text}{' '}
                <Text
                  style={[styles.text, { fontSize: 16, fontWeight: 'bold' }]}
                >
                  {props.data?.average_score.toFixed(1)}
                  {' / '}
                  {props.data?.scoring_ranges[2].max_score}
                  {' pkt'}
                </Text>
              </Text>

              <Text style={[styles.text, { flex: 1 }]}>
                {pdf.p_wynik_2_2_2.text}{' '}
              </Text>
            </View>
          </View>

          <Text style={[styles.text, pdf.p_wynik_2_3.style ?? {}]}>
            {pdf.p_wynik_2_3.text}
          </Text>

          <View style={styles.listItem}>
            <Text style={{ paddingLeft: 20 }}>
              <PdfCircle type={'FA-SLD'} size={14} color={SIGNALS[0].color} />
              {avaregaPatients[2].toFixed(1)} %
            </Text>
            <Text style={[styles.text, pdf.li_wynik_2_3_3.style ?? {}]}>
              {pdf.li_wynik_2_3_3.text}
            </Text>
          </View>

          <View style={styles.listItem}>
            <Text style={{ paddingLeft: 20 }}>
              <PdfCircle type={'FA-SLD'} size={14} color={SIGNALS[1].color} />
              {avaregaPatients[1].toFixed(1)} %
            </Text>
            <Text style={[styles.text, pdf.li_wynik_2_3_2.style ?? {}]}>
              {pdf.li_wynik_2_3_2.text}
            </Text>
          </View>

          <View style={styles.listItem}>
            <Text style={{ paddingLeft: 20 }}>
              <PdfCircle type={'FA-SLD'} size={14} color={SIGNALS[2].color} />
              {avaregaPatients[0].toFixed(1)} %
            </Text>
            <Text style={[styles.text, pdf.li_wynik_2_3_1.style ?? {}]}>
              {pdf.li_wynik_2_3_1.text}
            </Text>
          </View>

          <View style={[styles.imageWrapper, { marginTop: 40 }]}>
            <Image
              style={{ width: 515, height: (515 * 672) / 1920 }}
              src={reasonsPNG}
            />
          </View>
        </View>

        {/*Strefy*/}

        <View style={styles.section} break>
          <Text style={[styles.text, pdf.strefa_3.style ?? {}]}>
            <PdfCircle type={'FA-SLD'} size={14} color={SIGNALS[0].color} />
            {pdf.strefa_3.text}
            {`(${props.data?.scoring_ranges[2].min_score}–${props.data?.scoring_ranges[2].max_score} pkt / ${max})`}
            {pdf.strefa_3a.text}
          </Text>
          <Text style={[styles.text, pdf.p_strefa_3_1.style ?? {}]}>
            {pdf.p_strefa_3_1.text}
          </Text>
          <Text style={[styles.text, pdf.p_strefa_3_2.style ?? {}]}>
            {pdf.p_strefa_3_2.text}
          </Text>
          <Text style={[styles.text, pdf.p_strefa_3_3.style ?? {}]}>
            {pdf.p_strefa_3_3.text}
          </Text>
        </View>

        <View style={[styles.section, { paddingVertical: 0 }]}>
          <Text style={[styles.text, pdf.strefa_2.style ?? {}]}>
            <PdfCircle type={'FA-SLD'} size={14} color={SIGNALS[1].color} />
            {pdf.strefa_2.text}
            {`(${props.data?.scoring_ranges[1].min_score}–${props.data?.scoring_ranges[1].max_score} pkt / ${max})`}
            {pdf.strefa_2a.text}
          </Text>
          <Text style={[styles.text, pdf.p_strefa_2_1.style ?? {}]}>
            {pdf.p_strefa_2_1.text}
          </Text>
          <Text style={[styles.text, pdf.p_strefa_2_2.style ?? {}]}>
            {pdf.p_strefa_2_2.text}
          </Text>
          <Text style={[styles.text, pdf.p_strefa_2_3.style ?? {}]}>
            {pdf.p_strefa_2_3.text}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.text, pdf.strefa_1.style ?? {}]}>
            <PdfCircle type={'FA-SLD'} size={14} color={SIGNALS[2].color} />
            {pdf.strefa_1.text}
            {`(${props.data?.scoring_ranges[0].min_score}–${props.data?.scoring_ranges[0].max_score} pkt / ${max})`}
            {pdf.strefa_1a.text}
          </Text>
          <Text style={[styles.text, pdf.p_strefa_1_1.style ?? {}]}>
            {pdf.p_strefa_1_1.text}
          </Text>
          <Text style={[styles.text, pdf.p_strefa_1_2.style ?? {}]}>
            {pdf.p_strefa_1_2.text}
          </Text>
          <Text style={[styles.text, pdf.p_strefa_1_3.style ?? {}]}>
            {pdf.p_strefa_1_3.text}
          </Text>
          <Text style={[styles.text, pdf.p_strefa_1_4.style ?? {}]}>
            {pdf.p_strefa_1_4.text}
          </Text>
        </View>

        {/* Sygnaly */}
        <View style={styles.signals} break>
          <View style={[styles.imageWrapper]}>
            <Image
              style={{ width: 515, height: (515 * 840) / 1920 }}
              src={signalsPNG}
            />
          </View>

          {rows.map((row, rowIndex) => (
            <View key={rowIndex} style={styles.signalsRow} wrap={false}>
              {row.map((item, itemIndex) => (
                <Signals
                  key={itemIndex}
                  conclusion={item}
                  total={props.data?.total_patients_count}
                />
              ))}
            </View>
          ))}
        </View>

        {/*Podsumowanie*/}
        <View style={styles.section} break>
          <View style={styles.imageWrapper}>
            <Image
              style={{ width: 515, height: (515 * 1080) / 1920 }}
              src={analizePNG}
            />
          </View>
          <View style={[styles.imageWrapper, { marginTop: -10 }]}>
            <Image
              style={{ width: 515, height: (515 * 805) / 1920 }}
              src={coachPNG}
            />
          </View>

          <Text style={[styles.text, pdf.p_summary_1_1.style ?? {}]}>
            {pdf.p_summary_1_1.text}
          </Text>
          <Text style={[styles.text, pdf.p_summary_1_1a.style ?? {}]}>
            {pdf.p_summary_1_1a.text}
          </Text>

          <Text style={[styles.text, pdf.p_summary_1_2.style ?? {}]}>
            {pdf.p_summary_1_2.text}
          </Text>

          <View style={styles.listItem}>
            <PdfCircle type={'FA-SLD'} size={4} />
            <Text style={[styles.text, pdf.li_summary_1_2_1.style ?? {}]}>
              {pdf.li_summary_1_2_1.text}
            </Text>
          </View>

          <View style={styles.listItem}>
            <PdfCircle type={'FA-SLD'} size={4} />
            <Text style={[styles.text, pdf.li_summary_1_2_2.style ?? {}]}>
              {pdf.li_summary_1_2_2.text}
            </Text>
          </View>

          <View style={styles.listItem}>
            <PdfCircle type={'FA-SLD'} size={4} />
            <Text style={[styles.text, pdf.li_summary_1_2_3.style ?? {}]}>
              {pdf.li_summary_1_2_3.text}
            </Text>
          </View>

          <View style={styles.listItem}>
            <PdfCircle type={'FA-SLD'} size={4} />
            <Text style={[styles.text, pdf.li_summary_1_2_4.style ?? {}]}>
              {pdf.li_summary_1_2_4.text}
            </Text>
          </View>

          <View style={styles.listItem}>
            <PdfCircle type={'FA-SLD'} size={4} />
            <Text style={[styles.text, pdf.li_summary_1_2_5.style ?? {}]}>
              {pdf.li_summary_1_2_5.text}
            </Text>
          </View>

          <Text style={[styles.text, pdf.p_summary_1_3.style ?? {}]}>
            {pdf.p_summary_1_3.text}
          </Text>
          <Text style={[styles.text, pdf.p_summary_1_4.style ?? {}]}>
            {pdf.p_summary_1_4.text}
          </Text>
        </View>

        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  )
}

export default SurveyReportPDF
